import { createDotGlobePattern } from "./internal/dotGlobeCore";

export const key = "dot-globe-corner";

// Oversized globe pinned to the bottom-right corner.
//
// - radius: scaled to the smaller canvas dimension so it always feels
//   substantial; clamped so it doesn't dwarf very small previews.
// - center: pushed past the bottom-right edge so only the upper-left arc of
//   the sphere intrudes into the canvas. The offsets are a fraction of the
//   radius so the visible "slice" stays consistent at every size.
// - rotationSpeed: half the default so the sweep feels stately rather than
//   nervous when the globe takes up so much of the frame.
const VISIBLE_FRACTION = 0.55;
const SIZE_RATIO = 0.85;
const MIN_RADIUS = 180;
const MAX_RADIUS = 720;
const ROTATION_SPEED = 0.0017;

export default createDotGlobePattern({
  placement: ({ width, height }) => {
    const radius = Math.max(
      MIN_RADIUS,
      Math.min(MAX_RADIUS, Math.min(width, height) * SIZE_RATIO),
    );
    const inset = radius * VISIBLE_FRACTION;
    return {
      cx: width - inset * 0.4,
      cy: height - inset * 0.4,
      radius,
    };
  },
  rotationSpeed: ROTATION_SPEED,
});
